import createNormalizer from 'utils/createNormalizer';

import {
  designOptionsSchema,
  inCartModelsWithTemplatesSchemaEntity,
} from '../schemas';

export const normalizeOptions = createNormalizer({
  options: designOptionsSchema,
});

export const normalizeModels = createNormalizer({
  models: [inCartModelsWithTemplatesSchemaEntity],
});
